import { api } from "@/api/axios.ts";
import {
  ApiTemplate,
  ApiTemplateCompiled,
  ApiTemplateSavePayload,
} from "@/types/template.types.ts";

export const apiTemplates = {
  getAll: () => {
    return api.get<ApiTemplate[]>(`/api/v1/templates`);
  },
  create: (payload: ApiTemplateSavePayload) => {
    return api.post<ApiTemplate>(`/api/v1/templates`, payload);
  },
  update: (id: number, payload: ApiTemplateSavePayload) => {
    return api.put<ApiTemplate>(`/api/v1/templates/${id}`, payload);
  },
  delete: (id: number) => {
    return api.delete(`/api/v1/templates/${id}`);
  },
  preview: (id: number, candidateId: number) => {
    return api.get<ApiTemplateCompiled>(
      `/api/v1/templates/${id}/preview?candidate_id=${candidateId}`
    );
  },
};
